export default function findParents(graph, nodeId) {
  return graph.edges
    .filter(edge => edge.to === nodeId)
    .map(edge => graph.nodes.find(node => node.id === edge.from));
}